import { ActionReducerMapBuilder } from '@reduxjs/toolkit';
import { StationsState } from '../../types';

import { getStationsPriceReportSettings } from '../operations/getStationsPriceReportSettings';

import { STATUS_LOADING } from 'common/constants';

export const setStationsPriceReportSettings = (
  builder: ActionReducerMapBuilder<StationsState>
) => builder
  .addCase(getStationsPriceReportSettings.pending, (state) => {
    state.stationsPriceReportSettings.loadingStatus = STATUS_LOADING.load;
  })
  .addCase(getStationsPriceReportSettings.fulfilled, (state, { payload }) => {
    state.stationsPriceReportSettings.loadingStatus = STATUS_LOADING.done;
    state.stationsPriceReportSettings.data = payload;
  })
  .addCase(getStationsPriceReportSettings.rejected, (state) => {
    state.stationsPriceReportSettings.loadingStatus = STATUS_LOADING.error;
  });
